import { BLOCKS } from '@contentful/rich-text-types'
import { ContentType } from '@entries/content-types'
import ContentfulInformationButton from '@entries/contentful-information-button'
import { withDisplayName } from '@hocs/with-display-name'
import RichText from '@resolvers/rich-text'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulNumberedPunchlineRightLeftTextWithImage: Utils.EntryFC<
  Queries.ContentfulNumberedPunchlineRightLeftTextWithImageFragment
> = ({
  content: { amount, symbol, textUnderAmount },
  entryInspectorProps,
  fieldInspectorProps,
}) => (
  <div className="flex flex-col pb-4" {...entryInspectorProps()}>
    <div className="flex">
      <span
        className="text-[80px]/[80px] font-medium text-amplification-black-premium laptop:text-[100px]/[100px] laptopL:text-[120px]/[120px]"
        {...fieldInspectorProps({ fieldId: 'amount' })}
      >
        {amount}
      </span>
      <div className="flex flex-col justify-between py-2 laptop:py-4">
        <span
          className="text-[16px]/[24px] opacity-50 laptop:text-[20px]/[20px]"
          {...fieldInspectorProps({ fieldId: 'symbol' })}
        >
          {symbol}
        </span>
      </div>
    </div>
    <RichText
      {...fieldInspectorProps({ fieldId: 'textUnderAmount' })}
      content={textUnderAmount}
      options={{
        renderNode: {
          [BLOCKS.PARAGRAPH]: (_, children) => (
            <p className="mb-2 text-center text-[16px]/[24px] text-amplification-black-premium opacity-70 laptop:text-[20px]/[20px] laptopL:text-left">
              {children}
            </p>
          ),
          [BLOCKS.EMBEDDED_ENTRY]: {
            [ContentType.ContentfulInformationPanel]:
              ContentfulInformationButton,
          },
        },
      }}
    />
  </div>
)

export const query = graphql`
  fragment ContentfulNumberedPunchlineRightLeftTextWithImage on ContentfulNumberedPunchline {
    ...ContentfulEntry
    amount
    symbol
    textUnderAmount {
      rich
      references {
        ...ContentfulInformationButton
      }
    }
  }
`
export default withDisplayName(
  ContentfulNumberedPunchlineRightLeftTextWithImage,
  'ContentfulNumberedPunchlineRightLeftTextWithImage'
)
